// extracted by mini-css-extract-plugin
export default {"paginate":"Paginate_paginate__Ewe7Z","botoncito":"Paginate_botoncito__lI9Sr","botoncitoSelected":"Paginate_botoncitoSelected__bur1k"};